import { WarningAmber as WarningIcon } from '@mui/icons-material';

import {
  IntegrationRequestStatus,
  type IntegrationRequestDetail,
} from '../../../../models/IntegrationRequest';

const RequestAlerts = ({ request }: { request: IntegrationRequestDetail }) => (
  <>
    {request.status === IntegrationRequestStatus.OBSERVED && request.observation && (
      <div className='rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800'>
        <strong>Observación de TI:</strong> {request.observation}
      </div>
    )}
    {request.hasLegacyOrders && (
      <div className='flex gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800'>
        <WarningIcon fontSize='small' />
        <span>El comercio está integrado en el sistema anterior.</span>
      </div>
    )}
  </>
);

export default RequestAlerts;
